module.exports = dependencies['react']['16']['module'];